// extracted by mini-css-extract-plugin
module.exports = {"mediumCard":"styles_mediumCard__3PXQr"};